import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

const Scrollbars = props => <SimpleBar {...props} />;

export default React.memo(Scrollbars);
